var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useContext } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Fab from '@mui/material/Fab';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LogoutIcon from '@mui/icons-material/Logout';
import useMediaQuery from '@mui/material/useMediaQuery';
import ApiContext from '../contexts/apiContext';
import ChatContext from '../contexts/chatContext';
import { ADMIN_ROLE, POWER_USER_ROLE } from '../constants';
import { updateChat } from '../api';
import LoggedInUser from './LoggedInUser';
import LanguageSelector from './LanguageSelector';
import ThemeSelector from './ThemeSelector';
import TemperatureSelector from './TemperatureSelector';
import UserRoleCheck from './UserRoleCheck';
import DataSourceSelector from './DataSourceSelector';
var Menu = function (_a) {
    var children = _a.children, header = _a.header, footer = _a.footer;
    var isDesktop = useMediaQuery('(min-width:768px)');
    var _b = useState(isDesktop), drawerOpen = _b[0], setDrawerOpen = _b[1];
    var apiBaseUrl = useContext(ApiContext).apiBaseUrl;
    var _c = useContext(ChatContext), chat = _c.chat, dispatch = _c.dispatch;
    useEffect(function () {
        setDrawerOpen(isDesktop);
    }, [isDesktop]);
    var handleToggleDrawer = function () { return setDrawerOpen(!drawerOpen); };
    var setSelectedDataSourceId = function (ragSourceId) { return __awaiter(void 0, void 0, void 0, function () {
        var newRagSourceId, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(chat && dispatch)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    newRagSourceId = ragSourceId || null;
                    return [4 /*yield*/, updateChat(apiBaseUrl, { id: chat.id, ragSourceId: newRagSourceId })];
                case 2:
                    _a.sent();
                    dispatch({
                        state: {
                            id: chat.id,
                            ragSourceId: newRagSourceId
                        },
                        type: 'edit_chat_rag_source_id'
                    });
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsxs(Drawer, { variant: isDesktop ? 'persistent' : 'temporary', anchor: "left", open: drawerOpen, onClose: handleToggleDrawer, PaperProps: {
                    sx: { width: '225px' }
                }, children: [_jsx(Box, { position: "fixed", right: 0, top: 0, pt: 2, pr: 2, zIndex: 2, children: _jsxs(Stack, { spacing: 2, children: [chat && (_jsx(Paper, { sx: { width: 200 }, children: _jsx(DataSourceSelector, { api: chat.api, selectedDataSourceId: chat.ragSourceId, setSelectedDataSourceId: setSelectedDataSourceId }) })), _jsx(Paper, { sx: { alignSelf: 'flex-end', p: 2 }, children: _jsxs(Stack, { spacing: 2, children: [_jsx(LanguageSelector, {}), _jsx(ThemeSelector, {}), _jsx(UserRoleCheck, { roles: [ADMIN_ROLE, POWER_USER_ROLE], children: _jsx(TemperatureSelector, {}) })] }) })] }) }), _jsxs(Box, { display: "flex", flexDirection: "row", flexWrap: "nowrap", justifyContent: header ? 'space-between' : 'flex-end', pt: 2, pl: 2, pb: 2, children: [header, _jsx(IconButton, { onClick: handleToggleDrawer, children: _jsx(ChevronLeftIcon, {}) })] }), _jsx(Divider, {}), children, _jsx(Divider, {}), footer, _jsx(Button, { variant: "outlined", startIcon: _jsx(LogoutIcon, {}), href: "".concat(apiBaseUrl, "/auth/logout?redirectUrl=").concat(new URL('/logged-out', window.location.href)), sx: { ml: 2, mr: 2, mt: 2 }, children: "Logout" }), _jsx(LoggedInUser, {})] }), !drawerOpen && (_jsx(Box, { position: "fixed", left: 0, top: 0, pt: 2, pl: 2, zIndex: 2, children: _jsx(Fab, { size: "small", onClick: handleToggleDrawer, children: _jsx(ChevronRightIcon, {}) }) }))] }));
};
export default Menu;
